import styled from 'styled-components'
import { ScreenSizes } from 'src/styles'

type WrapperProps = {
  $open?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  .tiptap {
    color: var(--gray-900) !important;
    padding: var(--spacer-2) var(--spacer-3) !important;
    font-size: 0.875rem !important;
    min-height: ${({ $open }) => ($open ? '7.25rem' : '2rem')};
    transition: min-height 0.4s cubic-bezier(0.72, 0.01, 0.31, 0.96);

    p.is-editor-empty {
      height: 2.5rem;

      @media (min-width: ${ScreenSizes.sm}) {
        height: auto;
      }
    }

    p.is-editor-empty:first-child::before {
      color: var(--gray-500);
      width: calc(100% - 2.875rem);
      line-height: 1.3125rem;
    }
  }
`

Wrapper.displayName = 'Wrapper'

export const InputWrapper = styled.div`
  max-width: calc(100% - 2.75rem);
  transition: border-radius 0.6s cubic-bezier(0.72, 0.01, 0.31, 0.96);
`

InputWrapper.displayName = 'InputWrapper'
